/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import {
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Modal,
  Form,
  Col
} from "react-bootstrap";
import * as API from "Front/api/billingCycle";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import { style } from "Admin/variables/Variables.jsx";
import Radio from "Front/elements/CustomRadio/CustomRadio.jsx";
import CustomBillNumberModal from "../BillingModule/CustomBillNumber";
import { setCustomBillNumber } from "../../../api/billing";


const BillingCycle = () => {
  let clinicId = localStorage.clinicId;
  const [billingDay, setBillingDay] = useState("");
  const [alert, setAlert] = useState(null);
  const notificationSystem = useRef(null);
  const [preferenceTypes, setPreferenceButton] = useState({
    useBillModule: localStorage.getItem("useBillModule") === "true"
      ? "yes"
      : "no",
    billCreatedByEducator: localStorage.getItem("billCreatedByEducator") === "true" ? "yes"
      : "no",
    billCreatedByReceptionist: localStorage.getItem("billCreatedByReceptionist") === "true"
      ? "yes"
      : "no",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showModalForCustomBillNumber, setShowModalCustomBillNUmber] = useState(false)

  const fetchBillingDay = async () => {
    let data = {
      clinicId,
    };
    let res = await API.getBillingCycle(data);
    setBillingDay(
      res.data.data.length > 0 ? res.data.data[0].numberOfDays : 14
    );
  };

  useEffect(() => {
    fetchBillingDay();
  }, []);

  let items = [];
  for (let i = 1; i <= 30; i++) {
    items.push(<option value={i}>{i}</option>);
  }

  const successAlert = (msg) => {
    const notification = notificationSystem.current;
    notification.addNotification({
      title: (
        <span
          data-notify="icon"
          className="pe-7s-check"
          style={{
            fontSize: "30px",
            color: "#fff",
            padding: "0px !important",
            top: "0% !important",
          }}
        ></span>
      ),
      message: <div>{msg}</div>,
      level: "success",
      position: "tr",
      autoDismiss: 2,
    });

    setTimeout(function () {
      setAlert(null);
    }, 3000);
  };

  const handleSelect = async (e) => {
    setBillingDay(e.target.value);
  };

  const inputHandler = (e, name, value) => {
    let saveFormData = preferenceTypes;
    saveFormData[name] = value;
    setPreferenceButton({ ...saveFormData });
  };

  const handleSetCustomBillNumber = async (num) => {
    try {
      let resp = await setCustomBillNumber({ "billStartIndex": num?.toString() });
      if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
        localStorage.setItem("askForCustomBillNumber", "false");
        localStorage.setItem("billStartNumber", num?.toString())
        saveData();
      } else {
        console.error("Failed to set custom bill number:", resp?.data?.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error while setting custom bill number:", error);
      setAlert(
        <SweetAlert
          danger
          title="Error"
          onConfirm={() => setAlert(null)}
        >
          Something went wrong while setting the custom bill number.
        </SweetAlert>
      );
    } finally {
      setShowModalCustomBillNUmber(false);
    }
  };


  const handleSave = () => {
    const { billCreatedByEducator, useBillModule, billCreatedByReceptionist } = preferenceTypes
    if (useBillModule === "yes" && localStorage.getItem("askForCustomBillNumber") === "true") {
      setShowModalCustomBillNUmber(true)
      return
    }
    saveData()
  }

  const saveData = async () => {
    setIsLoading(true);
    let numberOfDays = billingDay,
      paymentAmount = "Yes";

    const { billCreatedByEducator, useBillModule, billCreatedByReceptionist } = preferenceTypes

    let paymentSetting = [
      {
        numberOfDays,
        paymentAmount,
        useBillModule,
        billCreatedByEducator,
        billCreatedByReceptionist
      },
    ];
    let data = {
      clinicId,
      paymentSetting,
    };

    let resp = await API.addBillingCycle(data);
    //console.log(resp);
    if (resp) {
      //setInsulinModel(false);
      localStorage.setItem(
        "useBillModule",
        preferenceTypes.useBillModule === "yes" ? true : false
      );
      localStorage.setItem(
        "billCreatedByEducator",
        preferenceTypes.billCreatedByEducator
      );
      localStorage.setItem(
        "billCreatedByReceptionist",
        preferenceTypes.billCreatedByReceptionist
      );
      successAlert("Data saved successfully");
    } else {
      successAlert("Something went wrong.");
    }
  };

  return (
    <div className="preference-to-set">
      {alert}
      <NotificationSystem ref={notificationSystem} style={style} />
      <div className="card">
        <h4 className="title">
          Consultation Validity Period To Charge Fee
          <FormControl
            style={{ width: "auto" }}
            componentClass="select"
            placeholder="select"
            name="billing"
            onChange={handleSelect}
            value={billingDay}
          >
            {items}
          </FormControl>
          Days
        </h4>
        {/* <FormGroup controlId="formControlsSelect">
     
        </FormGroup> */}
        <hr />
        <Form>
          <div className="card">
            {/* <h4 className="title">App Related Settings</h4> */}
            <div className="content">
              <div className="row">
                <div className="col-sm-8">
                  {" "}
                  Use Billing Module *
                </div>
                <div className="col-sm-4">
                  <div className="row">
                    <div className="col-sm-4">
                      <Radio
                        number="1"
                        option="yes"
                        name="useBillModule"
                        label="Yes"
                        checked={
                          preferenceTypes.useBillModule === "yes"
                            ? "checked"
                            : ""
                        }
                        onClick={(e) => inputHandler(e, "useBillModule", "yes")}
                      />
                    </div>
                    <div className="col-sm-4">
                      <Radio
                        number="2"
                        option="no"
                        name="useBillModule"
                        label="No"
                        checked={
                          preferenceTypes.useBillModule === "no"
                            ? "checked"
                            : ""
                        }
                        onClick={(e) => inputHandler(e, "useBillModule", "no")}
                        defaultChecked
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-sm-8">
                  {" "}
                  Bill <small>(Created by educator)</small> *
                </div>
                <div className="col-sm-4">
                  <div className="row">
                    <div className="col-sm-4">
                      <Radio
                        number="3"
                        option="yes"
                        name="billCreatedByEducator"
                        label="Yes"
                        checked={
                          preferenceTypes.billCreatedByEducator === "yes"
                            ? "checked"
                            : ""
                        }
                        onClick={(e) => inputHandler(e, "billCreatedByEducator", "yes")}
                      />
                    </div>
                    <div className="col-sm-4">
                      <Radio
                        number="4"
                        option="no"
                        name="billCreatedByEducator"
                        label="No"
                        checked={
                          preferenceTypes.billCreatedByEducator === "no"
                            ? "checked"
                            : ""
                        }
                        onClick={(e) => inputHandler(e, "billCreatedByEducator", "no")}
                        defaultChecked
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />


              <div className="row">
                <div className="col-sm-8">
                  {" "}
                  Bills <small>(Created by receptionist)</small> *
                </div>
                <div className="col-sm-4">
                  <div className="row">
                    <div className="col-sm-4">
                      <Radio
                        number="5"
                        option="yes"
                        name="billCreatedByReceptionist"
                        label="Yes"
                        checked={
                          preferenceTypes.billCreatedByReceptionist === "yes"
                            ? "checked"
                            : ""
                        }
                        onClick={(e) => inputHandler(e, "billCreatedByReceptionist", "yes")}
                      />
                    </div>
                    <div className="col-sm-4">
                      <Radio
                        number="6"
                        option="no"
                        name="billCreatedByReceptionist"
                        label="No"
                        checked={
                          preferenceTypes.billCreatedByReceptionist === "no"
                            ? "checked"
                            : ""
                        }
                        onClick={(e) => inputHandler(e, "billCreatedByReceptionist", "no")}
                        defaultChecked
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              <div className="row">
                <Col sm={12} md={6}>
                  <button
                    type="button"
                    className="btn-fill btn-wd btn btn-info"
                    onClick={() => handleSave()}
                  >
                    Save
                  </button>
                </Col>
                <Col mdOffset={2} sm={12} md={6}>
                  {/* {successMsg !== "" && (
                <p className="alert-heading" style={{ color: "#155724" }}>
                  {successMsg}
                </p>
              )} */}
                </Col>

                {/* <Col sm={12} md={6}>
                  {isLoading ? (
                    <Loading
                      type="bars"
                      color="#000000"
                      style={{ margin: "0px auto", width: "40px" }}
                    />
                  ) : (
                    ""
                  )}</Col> */}
              </div>


            </div>
          </div>
        </Form>
      </div>
      {showModalForCustomBillNumber &&
        <CustomBillNumberModal
          show={showModalForCustomBillNumber}
          onClose={() => setShowModalCustomBillNUmber(false)}
          onSave={(num) => {
            handleSetCustomBillNumber(num)
          }}
        />

      }
    </div>
  );
};
export default withRouter(BillingCycle);
